import { store } from '../store/store'
import * as actionTypes from '@/store/action-types'

import MainApp from '@/MainApp'

import { createRouter, createWebHistory } from 'vue-router'

// ==========================================
// MAIN BUNDLE - Eager load (critical path)
// ==========================================
import Dash from '@/components/containers/Dash'
import Home from '@/views/Home'
import Dashboard from '@/views/Dashboard'
import TokenLogin from '@/views/TokenLogin'
import FormsListView from '@/views/FormsListView'
import UserList from '@/views/UserList'
import Subscription from '@/views/Subscription'
import Billing from '@/views/Billing'


// ==========================================
// LAZY LOAD - Auth (not needed after login)
// ==========================================
const Login = () => import(/* webpackChunkName: "auth" */ '@/views/Login')
const VerifyEmail = () => import(/* webpackChunkName: "auth" */ '@/views/VerifyEmail')
const VerifyEmailForm = () => import(/* webpackChunkName: "auth" */ '@/components/authentication/VerifyEmailForm')
const ResetPasswordForm = () => import(/* webpackChunkName: "auth" */ '@/views/ResetPasswordForm')
const ForgotPassword = () => import(/* webpackChunkName: "auth" */ '@/components/authentication/ForgotPassword')
const Register = () => import(/* webpackChunkName: "auth" */ '@/views/Register')

// ==========================================
// LAZY LOAD - Forms (prefetched for fast access)
// ==========================================
const FormCreate = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormCreate')
const FormVariantCreate = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormVariantCreate')
const FormEmbed = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/components/FormEmbed')
const FormSettings = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/components/FormSettings')
const FormLeads = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/components/FormLeads')
const FormOverview = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormOverview')
const FormDetail = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormDetail')
const FormTrackingEvents = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormDetail/FormTrackingEvents')
const FormVariantEdit = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormVariantEdit')
const FormExperimentsOverview = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormExperimentsOverview')
const FormExperimentDetail = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormExperimentDetail')
const FormShare = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormShare')
const FormArchiveList = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormDetail/FormArchiveList')
const FormBrowseTemplate = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormBrowseTemplate')
const FormUrlBuilder = () => import(/* webpackChunkName: "forms" */ /* webpackPrefetch: true */ '@/views/FormDetail/FormUrlBuilder')

// Form endings (separate chunk, prefetched)
const AnswerBased = () => import(/* webpackChunkName: "forms-endings" */ /* webpackPrefetch: true */ '@/components/form-builder/Elements/AnswerBased')
const VisitorBased = () => import(/* webpackChunkName: "forms-endings" */ /* webpackPrefetch: true */ '@/components/form-builder/Elements/VisitorBased')
const ScoreBased = () => import(/* webpackChunkName: "forms-endings" */ /* webpackPrefetch: true */ '@/components/form-builder/Elements/ScoreBased')

// ==========================================
// LAZY LOAD - Integrations (prefetched)
// ==========================================
const ConnectionsList = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '@/views/ConnectionsList')
const FormConnectionsTab = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '@/views/FormConnectionsTab')
const FormConnections = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '../components/FormConnections')
const FormCreateConnection = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '@/views/FormCreateConnection')
const FormEditConnection = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '@/views/FormEditConnection')
const ZapierEmbed = () => import(/* webpackChunkName: "integrations" */ /* webpackPrefetch: true */ '@/components/form/integrations/ZapierEmbed.vue')

// ==========================================
// LAZY LOAD - Users (prefetched)
// ==========================================
const UserEdit = () => import(/* webpackChunkName: "users" */ /* webpackPrefetch: true */ '@/views/UserEdit')
const UserProfile = () => import(/* webpackChunkName: "users" */ /* webpackPrefetch: true */ '@/views/UserProfile')

// ==========================================
// LAZY LOAD - Landing Pages (no prefetch)
// ==========================================
const LandingPageCreate = () => import(/* webpackChunkName: "landing" */ '@/views/landingpage/LandingPageCreate')
const LandingPageEdit = () => import(/* webpackChunkName: "landing" */ '@/views/landingpage/LandingPageEdit')
const LandingPageList = () => import(/* webpackChunkName: "landing" */ '../views/landingpage/LandingPageList.vue')

// ==========================================
// LAZY LOAD - Settings (no prefetch)
// ==========================================
const Settings = () => import(/* webpackChunkName: "settings" */ '@/views/Settings')
const PartialLeads = () => import(/* webpackChunkName: "settings" */ '@/views/PartialLeads')
const BlacklistIps = () => import(/* webpackChunkName: "settings" */ '@/views/BlacklistIps')
const GoogleRecaptchaKeysList = () => import(/* webpackChunkName: "settings" */ '@/views/GoogleRecaptchaKeysList')
const UserSettings = () => import(/* webpackChunkName: "settings" */ '@/views/UserSettings')

// ==========================================
// LAZY LOAD - Lead Proof (no prefetch)
// ==========================================
const LeadProofManage = () => import(/* webpackChunkName: "leadproof" */ '@/components/LeadProofManage')
const LeadProofList = () => import(/* webpackChunkName: "leadproof" */ '@/views/LeadProofList')

// ==========================================
// LAZY LOAD - External Checkout (no prefetch)
// ==========================================
const ExternalCheckoutManage = () => import(/* webpackChunkName: "checkout" */ '@/components/ExternalCheckoutManage')
const ExternalCheckoutList = () => import(/* webpackChunkName: "checkout" */ '@/views/ExternalCheckoutList')

// ==========================================
// LAZY LOAD - Templates (no prefetch - admin feature)
// ==========================================
const FormTemplateList = () => import(/* webpackChunkName: "templates" */ '@/views/FormTemplateList')
const FormTemplateTaxonomy = () => import(/* webpackChunkName: "templates" */ '@/components/form-template-build/FormTemplateTaxonomy')
const FormTemplateBuilder = () => import(/* webpackChunkName: "templates" */ '@/components/form-template-build/FormTemplateBuilder')

// ==========================================
// LAZY LOAD - Package Builder (no prefetch - admin feature)
// ==========================================
const PackageBuilderList = () => import(/* webpackChunkName: "package-builder" */ '@/views/PackageBuilderList')
const PackageBuilder = () => import(/* webpackChunkName: "package-builder" */ '@/components/PackageBuilder')
const RolePackageBuilder = () => import(/* webpackChunkName: "package-builder" */ '@/components/RolePackageBuilder')
const PhishingFormsReview = () => import(/* webpackChunkName: "security-admin" */ '@/views/PhishingFormsReview')

// ==========================================
// LAZY LOAD - UTM Params (no prefetch)
// ==========================================
const UtmParamsManager = () => import(/* webpackChunkName: "utm" */ '@/components/UtmParamsManager')
const UtmParams = () => import(/* webpackChunkName: "utm" */ '@/views/UtmParamsList')
const ESignaturesOverview = () => import(/* webpackChunkName: "esignatures" */ '@/views/ESignaturesOverview')

// ==========================================
// LAZY LOAD - Misc (no prefetch)
// ==========================================
const chatPage = () => import(/* webpackChunkName: "misc" */ '@/views/chatPage')
const PageNotFound = () => import(/* webpackChunkName: "misc" */ '@/views/PageNotFound')
const Help = () => import(/* webpackChunkName: "misc" */ '@/views/Help')

const router = new createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      component: MainApp,
      children: [
        // frontend
        {
          path: "",
          name: "home",
          component: Home,
          meta: { showWhenLoggedIn: true },
        },
        // login related
        {
          path: "login",
          name: "login",
          component: Login,
          meta: {
            showWhenLoggedIn: false,
            title: "Log In – CliqForms",
            description:
              "Click here to log in to your CliqForms account and access your online forms and leads.",
          },
        },
        {
          path: "verify-email-form",
          name: "verifyEmailForm",
          component: VerifyEmailForm,
          meta: { showWhenLoggedIn: false },
        },
        {
          path: "verify-email/:userId/:token",
          name: "verifyEmail",
          component: VerifyEmail,
          meta: { showWhenLoggedIn: true },
        },
        {
          path: "forgot-password-form",
          name: "forgot-password-form",
          component: ForgotPassword,
          meta: {
            showWhenLoggedIn: false,
            title: "Forgot Password – CliqForms",
          },
        },
        {
          path: "reset-password-form/:userId/:token",
          name: "resetPasswordForm",
          component: ResetPasswordForm,
          meta: { showWhenLoggedIn: true },
        },
        {
          path: "token/login",
          name: "tokenLogin",
          component: TokenLogin,
          meta: {
            showWhenLoggedIn: true,
            title: "Log In – CliqForms",
            description:
              "Log In Here To Your CliqForms Account – The Fastest Way To Create Lead Capture And Multi-step Forms For Marketers.",
          },
        },
        // register related
        {
          path: "register",
          name: "register",
          component: Register,
          meta: {
            requiresAuth: false,
            showWhenLoggedIn: false,
            title: "Create Your Free Account – CliqForms",
            description:
              "Get Started With CliqForms To Increase Your Lead Capture Conversions With Better Online Forms. Sign Up Here For A Free Account To Test It Out Yourself.",
          },
        },
        // redirect for legacy register URL
        {
          path: "register-free-trial",
          redirect: { name: "register" },
        },
        // dashboard
        {
          path: "/dashboard",
          component: Dash,
          meta: { requiresAuth: true },
          children: [
            {
              path: "",
              name: "dashboard",
              component: Dashboard,
            },
            {
              path: "/users",
              name: "users.index",
              component: UserList,
            },
            {
              path: "/users/:id/edit",
              name: "users.edit",
              component: UserEdit,
            },
            {
              path: "/users/archive",
              name: "users.archive.list",
              component: UserList,
              meta: { requiresAuth: true },
            },
            {
              path: "/forms",
              name: "forms.index",
              component: FormsListView,
            },
            {
              path: "/forms/archive",
              name: "forms.archive.list",
              component: FormArchiveList,
              meta: { requiresAuth: true },
            },
            {
              path: "/forms/share",
              name: "form.share",
              component: FormShare,
            },
            {
              path: "/forms/:id/detail",
              component: FormDetail,
              children: [
                {
                  path: "connections",
                  component: FormConnectionsTab,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                  children: [
                    {
                      path: "",
                      name: "forms.detail.connectionstab.list",
                      component: FormConnections,
                      props: (route) => ({ formId: parseInt(route.params.id) }),
                    },
                    {
                      path: "create/:connectionType?",
                      name: "forms.detail.connectionstab.create",
                      component: FormCreateConnection,
                      props: (route) => ({ formId: parseInt(route.params.id) }),
                    },
                    {
                      path: "edit/:connectionId/:connectionType",
                      name: "forms.detail.connectionstab.edit",
                      component: FormEditConnection,
                      props: (route) => ({ formId: parseInt(route.params.id) }),
                    },
                  ],
                },
                {
                  path: "",
                  name: "forms.overview",
                  component: FormOverview,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                },
                {
                  path: "/forms/:id/share",
                  name: "forms.share",
                  component: FormEmbed,
                },
                {
                  path: "/forms/:id/settings",
                  name: "forms.settings",
                  component: FormSettings,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                },
                {
                  path: "/forms/:id/leads",
                  name: "forms.leads",
                  component: FormLeads,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                },
                {
                  path: "/forms/:id/tracking-events",
                  name: "forms.trackingEvents",
                  component: FormTrackingEvents,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                },
                {
                  path: "/forms/:id/url-builder",
                  name: "forms.urlBuilder",
                  component: FormUrlBuilder,
                  props: (route) => ({ formId: parseInt(route.params.id) }),
                },
                {
                  path: "/forms/:id/experiments",
                  name: "forms.experiments.overview",
                  component: FormExperimentsOverview,
                },
                {
                  path: "/forms/:id/experiments/:experimentId",
                  name: "forms.experiments.detail",
                  component: FormExperimentDetail,
                },
              ],
            },
            // landing pages
            {
              path: "/landingpages",
              name: "landingpages.index",
              component: LandingPageList,
              meta: { requiresAuth: true },
            },
            {
              path: "/googlerecaptchakeys",
              name: "googlerecaptchakeys",
              component: GoogleRecaptchaKeysList,
            },
            {
              path: "/connections-list",
              name: "connections.list",
              component: ConnectionsList,
            },
            {
              path: "/plans",
              name: "plans.index",
              component: Subscription,
            },
            {
              path: "/billing",
              name: "billing.index",
              component: Billing,
            },
            {
              path: "/lead-proofs-list",
              name: "leadproofs.index.list",
              component: LeadProofList,
            },
            {
              path: "/lead-proofs-create",
              name: "leadproofs.create",
              component: LeadProofManage,
            },
            {
              path: "/lead-proofs/:id/edit",
              name: "leadproofs.edit",
              component: LeadProofManage,
            },
            {
              path: "/external-checkout-list",
              name: "externalcheckout.index.list",
              component: ExternalCheckoutList,
            },
            {
              path: "/external-checkout-create",
              name: "externalcheckout.create",
              component: ExternalCheckoutManage,
            },
            {
              path: "/external-checkout/:id/edit",
              name: "externalcheckout.edit",
              component: ExternalCheckoutManage,
            },
            {
              path: "/help",
              name: "help.index",
              component: Help,
            },
            {
              path: "/partial-leads",
              name: "partialleads",
              component: PartialLeads,
            },
            {
              path: "/user-profile",
              name: "user.profile",
              component: UserProfile,
            },
            {
              path: "/settings",
              name: "settings",
              component: Settings,
            },
            {
              path: "/blacklist-ips",
              name: "blacklist.ips",
              component: BlacklistIps,
            },
            {
              path: "/template-builder-list",
              name: "template-builder.index.list",
              component: FormTemplateList,
            },
            {
              path: "/template-builder-taxonomy",
              name: "template-builder.taxonomy",
              component: FormTemplateTaxonomy,
            },
            {
              path: "/template-builder-create",
              name: "template-builder.create",
              component: FormTemplateBuilder,
            },
            {
              path: "/template-builder/:id/edit",
              name: "template-builder.edit",
              component: FormTemplateBuilder,
            },
            {
              path: "/user-settings",
              name: "user-settings",
              component: UserSettings,
            },
            {
              path: "/phishing-forms",
              name: "phishing-forms.index",
              component: PhishingFormsReview,
            },
            {
              path: "/package-builder-list",
              name: "package-builder.index.list",
              component: PackageBuilderList,
            },
            {
              path: "/package-builder-create",
              name: "package-builder.create",
              component: PackageBuilder,
            },
            {
              path: "/package-builder/:id/edit",
              name: "package-builder.edit",
              component: PackageBuilder,
            },
            {
              path: "/package-builder-role-manage",
              name: "package-builder.role.manage",
              component: RolePackageBuilder,
            },
            {
              path: "/package-builder-role/:role/edit",
              name: "package-builder.role.edit",
              component: PackageBuilder,
            },
            {
              path: "/esignatures",
              name: "esignatures.index",
              component: ESignaturesOverview,
            },
            {
              path: "/utm-params",
              name: "utmparams.index.list",
              component: UtmParams,
            },
            {
              path: "/utm-params-create",
              name: "utmparams.create",
              component: UtmParamsManager,
            },
            {
              path: "/utm-params/:id/edit",
              name: "utmparams.edit",
              component: UtmParamsManager,
            },
          ],
        },
        {
          path: "/forms/:id/zapier",
          name: "forms.zapier.embed",
          component: ZapierEmbed,
          meta: { requiresAuth: true },
          props: (route) => ({ formId: parseInt(route.params.id) }),
        },
        // chat
        {
          path: "/chat",
          name: "chat",
          component: chatPage,
        },
        {
          path: "/forms/create",
          name: "forms.create",
          component: FormCreate,
          meta: { requiresAuth: true },
        },
        {
          path: "/templates/:industry?",
          name: "templates",
          redirect: (to) => ({
            name: "forms.choose.template",
            params: { industry: to.params.industry },
          }),
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/choose/template/:industry?",
          name: "forms.choose.template",
          component: FormBrowseTemplate,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/:tab?",
          name: "forms.variants.edit",
          component: FormVariantEdit,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/answerbased/create",
          name: "forms.variants.answerbased.create",
          component: AnswerBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/answerbased/:endingId/edit",
          name: "forms.variants.answerbased.edit",
          component: AnswerBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/visitorbased/create",
          name: "forms.variants.visitorbased.create",
          component: VisitorBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/visitorbased/:endingId/edit",
          name: "forms.variants.visitorbased.edit",
          component: VisitorBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/scorebased/create",
          name: "forms.variants.score.create",
          component: ScoreBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings/scorebased/:endingId/edit",
          name: "forms.variants.score.edit",
          component: ScoreBased,
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/:variantId/edit/formendings",
          name: "forms.variants.edit.conditions",
          component: FormVariantEdit,
          props: (route) => ({ tab: 'formendings' }),
          meta: { requiresAuth: true },
        },
        {
          path: "/forms/:id/variants/create",
          name: "forms.variants.create",
          component: FormVariantCreate,
          meta: { requiresAuth: true },
        },
        // landing page
        {
          path: "/landingpages/create",
          name: "landingpages.create",
          component: LandingPageCreate,
          meta: { requiresAuth: true },
        },
        {
          path: "/landingpages/:refId/edit",
          name: "landingpages.edit",
          component: LandingPageEdit,
          meta: { requiresAuth: true },
        },
      ],
    },
    // 404
    {
      path: "/:catchAll(.*)",
      component: PageNotFound,
    },
  ],
  linkActiveClass: "active",
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "CliqForms"
  let meta = document.querySelector("meta[name=description]")

  if (meta && to.meta.description) {
    meta.content = to.meta.description
  }

  setTimeout(() => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      // protected routes
      if (!store?.getters?.isLoggedIn) {
        localStorage.setItem(
          "private_url",
          JSON.stringify({ name: to.name, params: to.params })
        )

        if (store.state.token) {
          // auto logout
          store.dispatch(actionTypes.LOGOUT_USER).then((result) => {
            next({
              path: "/login",
            })
          })
        } else {
          next({
            path: "/login",
          })
        }
      } else {
        next()
      }
    } else {
      // public routes
      if (!store?.getters?.isLoggedIn) {
        next()
      } else {
        if (to.matched.some((record) => record.meta.showWhenLoggedIn)) {
          next()
        } else {
          next({
            path: "/dashboard",
          })
        }
      }
    }
  }, 0)
})

export default router
